module.exports = function() {
  return new Worker(__webpack_public_path__ + "7a03c078778be66bbfb6.worker.js");
};